<template>
    <div :class="{'date-table-open': showDateTableForLeftFilters}">
        <template v-if="settings.FiltersDisplayOptions">
            <tickets-second-search-bar-left @toggleDateTable="toggleDateTable($event)"
                                            @apply="sendSecondFilterParams(...$event)"
                                            @clearAllFilters="clearAllFilters(true)"
                                            :rate="rate"
                                            :availability-price="availabilityPrice"
                                            :default-air-filter="defaultAirFilter"
                                            :tickets-price-limit="ticketsPriceLimit"
                                            :tickets-class-list="ticketsClassList"
                                            :tickets-class-checked="ticketsClassChecked"
                                            :tickets-class-multy="ticketsClassMulty"
                                            :tickets-transplantation-list="ticketsTransplantationList"
                                            :arrival-time="arrivalTime"
                                            :departure-time="departureTime"
                                            :tickets-departure-airports-checked="ticketsDepartureAirportsChecked"
                                            :tickets-departure-list="ticketsDepartureList"
                                            :tickets-arrival-airports-checked="ticketsArrivalAirportsChecked"
                                            :tickets-arrival-list="ticketsArrivalList"
                                            :tickets-airline-list="ticketsAirlineList"
                                            :tickets-airlines-checked="ticketsAirlinesChecked"
                                            :tickets-airline-multy="ticketsAirlineMulty"
                                            :fixed-filters="fixedFilters"
                                            :show-date-table-by-settings="showDateTable" />

            <!--Фильтр матрица дат-->
            <date-table v-if="showDateTableForLeftFilters"
                        @slideDate="slideDate(...$event)"
                        @setDate="setDate($event)"
                        :rate="rate"
                        :date-table-header="dateTableHeader"
                        :date-table-items="dateTableItems"
                        :direct-d-o-m="directDOM"
                        :localize-list="localizeList"/>


            <selected-filters
                    v-if="selectedFilters.length && !filterType"
                    :filters="selectedFilters"
                    @change="changeSelectedFilters($event)"
                    ref="selectedFilters"
            />
        </template>
        <div v-else ref="secondFilters" id="ticketsSecondFilters" :class="['second-search-bar-wrap', {'fixed': fixedFilters}]">
            <div :class="['second-search-bar',{'active': filterType}]">
                <div class="search-controlers">

                    <!--Контролер доп филтров(навигация)-->
                    <div @click="changeFilterType(3, true)" class="search-controler-item align-center">
                        <span ref="filterIcon">{{localizeList.filters}}</span>
                        <icon name="filter" class="angle-icon" width="20px" height="18px"  fill="#727272" />
                    </div>
                    <div v-if="showDateTable"
                         @click="changeFilterType(1)"
                         :class="['search-controler-item align-center',{'active': filterType === 1}]">
                        <span>{{localizeList.datesTable}}</span>
                        <svg class="angle-icon" width="8px" height="5px">
                            <use xlink:href="../../assets/images/sprite.svg#drop-angle"></use>
                        </svg>
                    </div>
                    <div v-if="!getWindowSettings.hideTicketPriceRangeFilter"
                         @click="changeFilterType(2)"
                         :class="['search-controler-item align-center',{'active': filterType === 2}]">
                        <span>{{localizeList.availabilityUpper}}</span>
                        <svg class="angle-icon" width="8px" height="5px">
                            <use xlink:href="../../assets/images/sprite.svg#drop-angle"></use>
                        </svg>
                    </div>
                    <div v-if="!getWindowSettings.hideTicketFlightFilter"
                         @click="changeFilterType(3)"
                         :class="['search-controler-item align-center',{'active': filterType === 3}]">
                        <span>{{localizeList.flightUpper2}}</span>
                        <svg class="angle-icon" width="8px" height="5px">
                            <use xlink:href="../../assets/images/sprite.svg#drop-angle"></use>
                        </svg>
                    </div>
                </div>
            </div>

            <div v-show="filterType" :class="['second-search-bar-list',{'active': filterType}]"
                 :style="{'paddingBottom': filterType === 3 ? '20px' : ''}">
                <date-table v-if="filterType === 1 && flexible"
                            @slideDate="slideDate(...$event)"
                            @setDate="setDate($event)"
                            :rate="rate"
                            :date-table-header="dateTableHeader"
                            :date-table-items="dateTableItems"
                            :direct-d-o-m="directDOM"
                            :localize-list="localizeList"/>

                <!-- Фильтр диапазон цен -->
                <div v-else-if="filterType === 2" class="availability-filter">
                    <!-- <div class="price-block">
                        <p class="price-text">
                            {{localizeList.priceUpper}}:
                            <span class="blue-text">
                            {{correctPrice(availabilityPrice[0], true)}} {{getCurrencyDisplayBySettings(rate)}} – {{correctPrice(availabilityPrice[1], true)}} {{getCurrencyDisplayBySettings(rate)}}
                        </span>
                        </p>
                        <base-slider v-model="availabilityPrice"
                                     @change="changePrice($event)"
                                     :size="ticketsPriceLimit"/>
                    </div> -->
                    <div class="common-price-block">
                        <p class="price-text">{{localizeList.availabilityPriceRangeUpper}}</p>
                        <div class="price-inputs">
                          <input type="text" class="price-input"
                          maxlength="9"
                          @input="(event) => availabilityPrice[0] = maskInputForNumber(event, 0)"
                          :value="availabilityPrice[0]"
                          @change="changePrice(availabilityPrice)">
                          <span class="dash"></span>
                          <input type="text" class="price-input" 
                          maxlength="9"
                          @input="(event) => availabilityPrice[1] = maskInputForNumber(event, 0)"
                          :value="availabilityPrice[1]"
                          @change="changePrice(availabilityPrice)">
                        </div>
                    </div>
                    <div class="done-btn">
                        <base-button @click="clearAllFilters(true)" background="var(--lighten-6-color)" color="#727272">
                            {{localizeList.resetFlightsUpper}}
                        </base-button>
                        <base-button v-if="useApplyFiltersButton"
                                     class="ml-5"
                                     :disabled="loaderStatus"
                                     @click="sendSecondFilterParams()">
                            <span v-if="!loaderStatus">{{localizeList.applyUpper}}</span>
                            <base-loader v-else width="84" size="22" weight="5"/>
                        </base-button>
                    </div>
                </div>

                <!--Фильтр перелет-->
                <div v-else-if="filterType === 3" class="tour-flight">
                    <div class="tour-flight-filter">
                        <div ref="line1" class="line1"></div>
                        <div ref="line2" class="line2"></div>
                        <div class="time-filter">
                            <div class="departure-there">
                                <p class="standard-text">
                                    {{localizeList.departureUpper}}:
                                    <span class="blue-bold-text">{{departureTime[0]|time}} – {{departureTime[1]|time}}</span>
                                </p>
                                <base-slider v-model="departureTime" @change="changeDepartureTime($event)"
                                             :size="[0, 1439]"/>
                            </div>
                            <div v-show="directDOM === 1" class="arrival-back">
                                <p class="standard-text">
                                    {{localizeList.arrivalUpper}}:
                                    <span class="blue-bold-text">{{arrivalTime[0]|time}} – {{arrivalTime[1]|time}}</span>
                                </p>
                                <base-slider v-model="arrivalTime" @change="changeArrivalTime($event)"
                                             :size="[0, 1439]"/>
                            </div>
                        </div>
                        <div class="airport-filter">
                            <p class="headline">{{localizeList.departureAirportUpper}}</p>
                            <base-input v-model="searchDeparture" class="departure-search"
                                        :placeholder="localizeList.titleUpper"
                                        clearable>
                                <svg width="20px" height="20px" fill="var(--lighten-7-color)">
                                    <use xlink:href="../../assets/images/sprite.svg#search"></use>
                                </svg>
                            </base-input>
                            <div class="flight-list airport-list">
                                <div v-for="(item, key) in ticketsDepartureList"
                                     :key="key">
                                    <div v-if="item.isShow && !(item.isDisabled && !ticketsDepartureAirportsChecked[item.Key])"
                                         class="flight-item">
                                        <checkbox v-model="ticketsDepartureAirportsChecked[item.Key]"
                                                  @change="changeTourDepartureAirports(item.Key, $event)">
                                            {{item.Name}}({{item.Code}})
                                        </checkbox>
                                    </div>
                                </div>
                                <div v-show="!ticketsDepartureList.length">
                                    <p class="standard-text not-result-text">{{localizeList.noResults}}</p>
                                </div>
                            </div>
                            <p class="headline">{{localizeList.arrivalAirportUpper}}</p>
                            <base-input v-model="searchArrival" class="arrival-search"
                                        :placeholder="localizeList.titleUpper"
                                        clearable>
                                <svg width="20px" height="20px" fill="var(--lighten-7-color)">
                                    <use xlink:href="../../assets/images/sprite.svg#search"></use>
                                </svg>
                            </base-input>
                            <div class="flight-list airport-list">
                                <div v-for="(item, key) in ticketsArrivalList"
                                     :key="key">
                                    <div v-if="item.isShow && !(item.isDisabled && !ticketsArrivalAirportsChecked[item.Key])"
                                         class="flight-item">
                                        <checkbox v-model="ticketsArrivalAirportsChecked[item.Key]"
                                                  @change="changeTourArrivalAirports(item.Key, $event)">
                                            {{item.Name}}({{item.Code}})
                                        </checkbox>
                                    </div>
                                </div>
                                <div v-show="!ticketsArrivalList.length">
                                    <p class="standard-text not-result-text">{{localizeList.noResults}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="transplantation-filter">
                            <p class="headline">{{localizeList.directsUpper}}</p>
                            <div class="flight-list">
                                <div v-for="(item, key) in ticketsTransplantationList"
                                     :key="key">
                                    <div class="flight-item">
                                        <checkbox v-model="item.isChecked" @change="changeTourTransplantation(key, $event)">
                                            {{localizeList[item.label]}}
                                        </checkbox>
                                    </div>
                                </div>
                            </div>

                            <p class="headline">{{localizeList.directsUpper}}</p>
                            <div class="flight-list">
                                <div v-for="(item, key) in ticketsTransplantationListTo"
                                     :key="key">
                                    <div class="flight-item">
                                        <checkbox v-model="item.isChecked" @change="changeTourTransplantationTo(key, $event)">
                                            {{localizeList[item.label]}}
                                        </checkbox>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div ref="airLineFilter" class="airline-filter">
                            <p class="headline">{{localizeList.airlineUpper}}</p>
                            <base-input v-model="searchAirline" class="airline-search"
                                        :placeholder="localizeList.titleUpper"
                                        clearable>
                                <svg width="20px" height="20px" fill="var(--lighten-7-color)">
                                    <use xlink:href="../../assets/images/sprite.svg#search"></use>
                                </svg>
                            </base-input>
                            <div class="flight-list airline-list">
                                <div v-for="(item, key) in ticketsAirlineList"
                                     :key="key">
                                    <div v-if="item.isShow && !(item.isDisabled && !ticketsAirlinesChecked[item.Key])" class="flight-item">
                                        <checkbox v-model="ticketsAirlinesChecked[item.Key]"
                                                  @change="changeTourAirlines(item.Key, $event)">
                                            {{item.Name}}
                                        </checkbox>
                                    </div>
                                </div>
                                <div v-show="!ticketsAirlineList.length">
                                    <p class="standard-text not-result-text">{{localizeList.noResults}}</p>
                                </div>
                            </div>
                            <div class="flight-item airline-combo border-t">
                                <checkbox v-model="ticketsAirlineMulty.isChecked" @change="changeTourAirlineMulty($event)">
                                    <p class="ellipsis">{{localizeList.allowCombineAirlines}}</p>
                                </checkbox>
                                <div class="help-icon popover"
                                     @mouseleave="hidePopover()"
                                     @mouseenter="showPopover(localizeList.allowCombineAirlinesDescr, $event)">
                                    <svg width="14px" height="14px" fill="var(--primary-color)">
                                        <use xlink:href="../../assets/images/sprite.svg#help"></use>
                                    </svg>
                                </div>
                            </div>

                            <p class="headline">{{localizeList.flightClass}}</p>
                            <div class="flight-list">
                                <div v-for="(item, key) in ticketsClassList"
                                     :key="key">
                                    <div v-if="item.isDisabled && !ticketsClassChecked[item.Key]" class="flight-item">
<!--                                        Combo Tariff-->
<!--                                        <checkbox v-model="ticketsClassChecked[item[0].Key]"-->
<!--                                                  @change="changeTicketClass(item, $event)"-->
<!--                                                  :disabled="item[0].isDisabled && !ticketsClassChecked[item[0].Key]">-->
<!--                                            {{item[0].Name}}-->
                                        <checkbox v-model="ticketsClassChecked[item.Key]"
                                                  @change="changeTourClass(item.Key, $event)">{{item.Name}}
                                        </checkbox>
                                    </div>
                                </div>
                                <div v-show="!ticketsClassList.length">
                                    <p class="standard-text not-result-text">{{localizeList.noResults}}</p>
                                </div>
                                <div class="flight-item border-t class-combo">
<!--                                    Combo Tariff-->
<!--                                    <checkbox v-model="ticketsClassMulty.isChecked" @change="changeTicketClassMulty($event)">-->
                                    <checkbox v-model="ticketsClassMulty.isChecked" @change="changeTourClassMulty($event)">
                                        <p class="ellipsis">{{localizeList.allowCombineTariffs}}</p>
                                    </checkbox>
                                    <div class="help-icon"
                                         @mouseleave="hidePopover()"
                                         @mouseenter="showPopover(localizeList.allowCombineTariffsDescr, $event)">
                                        <svg width="14px" height="14px" fill="var(--primary-color)">
                                            <use xlink:href="../../assets/images/sprite.svg#help"></use>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="btn-group">
                        <base-button @click="clearAllFilters(true)" background="var(--lighten-6-color)" color="#727272">
                            {{localizeList.resetFlightsUpper}}
                        </base-button>
                        <base-button v-if="useApplyFiltersButton"
                                     :disabled="loaderStatus"
                                     @click="sendSecondFilterParams()">
                            <span v-if="!loaderStatus">{{localizeList.applyUpper}}</span>
                            <base-loader v-else width="84" size="22" weight="5"/>
                        </base-button>
                    </div>
                </div>
            </div>

            <selected-filters
                    v-if="selectedFilters.length && !filterType"
                    :filters="selectedFilters"
                    @change="changeSelectedFilters($event)"
                    ref="selectedFilters"
            />
        </div>
        <div v-show="fixedFilters" id="mainTicketSecondFiltersSpace"></div>
    </div>
</template>

<script>
    import selectedFilters from "./selectedFilters";

    import {bus} from '../../main'
    import moment from 'moment'
    import TicketsSecondSearchBarLeft from "./leftFilters/ticketsSecondSearchBarLeft";
    import DateTable from "./dateTable";

    import * as mTypesTickets from "@/stores/modules/tickets/mutation_types";

    export default {
        name: "tickets-second-search-bar",
        components: {
            DateTable,
            TicketsSecondSearchBarLeft,
            "selected-filters": selectedFilters,
        },
        data() {
            return {
                API_URL: this.$store.getters['getApiUrl'],
                rate: null,
                ticketsSettings: null,
                focus: true,
                filterType: 0,
                cashFilterType: 0,
                priceGroup: [],
                sliderPosition: 0,
                dateTableHeader: [],
                dateTableItems: [],
                ticketsClassList: [],
                ticketsAirlineList: [],
                availabilityPrice: [],
                ticketsPriceLimit: [],
                searchDeparture: "",
                searchArrival: "",
                searchAirline: "",
                ticketsClassMulty: {
                    label: "Комбинировать классы",
                    isChecked: false
                },
                ticketsTransplantationList: [
                    {
                        label: "withoutDirectUpper",
                        value: 0,
                        isChecked: false,
                    },
                    {
                        label: "oneDirectUpper",
                        value: 1,
                        isChecked: false,
                    },
                    {
                        label: "twoOrMoreDirectUpper",
                        value: 2,
                        isChecked: false,
                    }
                ],
                ticketsTransplantationListTo: [
                    {
                        label: "withoutDirectUpper",
                        value: 0,
                        isChecked: false,
                    },
                    {
                        label: "oneDirectUpper",
                        value: 1,
                        isChecked: false,
                    },
                    {
                        label: "twoOrMoreDirectUpper",
                        value: 2,
                        isChecked: false,
                    }
                ],
                ticketsDepartureList: [],
                ticketsArrivalList: [],
                ticketsAirlineMulty: {
                    label: "Комбинировать компании",
                    isChecked: false,
                },
                departureTime: [0, 1439],
                arrivalTime: [0, 1439],
                ticketsClassChecked: {},
                ticketsDepartureAirportsChecked: {},
                ticketsArrivalAirportsChecked: {},
                ticketsAirlinesChecked: {},
                cashSecondFilters: null,
                localSecondFilters: {
                    // price: [0, 100000],
                    price: [],
                    aviaQuota: 7,
                    ticketsClass: [],
                    ticketsClassMulty: false,
                    ticketsTransplantation: [],
                    ticketsTransplantationTo: [],
                    ticketsDepartureAirports: [],
                    ticketsArrivalAirports: [],
                    ticketsAirlines: [],
                    ticketsAirlinesMulty: false,
                    departureTime: ["00:00", "23:59"],
                    arrivalTime: ["00:00", "23:59"],
                },
                loaderStatus: false,
                filtersChangeStatus: false,
                filterChange: [],
                priceChange: false,
                dTimeChange: false,
                aTimeChange: false,
                pageLoaderCountStatus: 0,
                selectedFilters: [],
                cashUrl: "",
                initDateTable: false,
                cashDate: {},
                directDOM: 1,
                isClickApply: false,
                waitSlideDate: false,
                fixedFilters: false,
                openDateTable: false,
                showDateTableForLeftFilters: false,
                defaultAirFilter: [],
                quotaItems: [
                    {
                        isChecked: false,
                        value: 1
                    },
                    {
                        isChecked: false,
                        value: 5
                    },
                    {
                        isChecked: false,
                        value: 7
                    }
                ],
            }
        },
        computed: {
            getWindowSettings() {
                return window.settings;
            },
            getAviaQuota() {
                return this.$store.getters['tickets/getAviaQuota']
            },
            settings() {
                return this.$store.getters['getSettings'];
            },
            useApplyFiltersButton() {
                return this.settings.UseApplyFiltersButton;
            },
            getResultList() {
                return this.$store.getters['tickets/getSearchResult']
            },
            dayMode() {
                let res = ["day", "day2", "days"];
                if (this.ticketsSettings && (this.ticketsSettings.TourSearchMode === 1 || this.ticketsSettings.TourSearchMode === 2)) {
                    res = ["night", "night2", "nights"]
                }
                return res
            },
            secondFilters() {
                return this.$store.getters['tickets/getSecondaryFiltersResult']
            },
            direct() {
                return this.$store.getters['tickets/getDirect']
            },
            flexible() {
                return this.$route.fullPath.includes("flexible")
            },
            showDateTable() {
                // return true;
              let settings = this.$store.getters['getSettings'];

              if (window.settings.ticketPriceTableOpen) {
                return this.flexible;
              }
              else if (window.settings.ticketPriceTableOpen === false) {
                return false;
              }
              else {
                  return this.flexible && settings.ShowPriceTableInAB;
              }
            }
        },
        created() {
            window.addEventListener("resize", this.resize);
            window.addEventListener("scroll", this.scroll);

            bus.$on("fixed-filters", (val) => {
                if (val) {
                    this.cashFilterType = this.filterType;
                    this.hide();
                } else {
                    this.filterType = this.cashFilterType;
                    this.$nextTick(() => {
                        this.resize()
                    })
                }

                this.fixedSecondFilters(val)
            });
            bus.$on("tickets-searched-client", () => {
                const settings = this.$store.getters['getSettings'];
                let type = window.settings.ticketAdditionalFilterOpen !== undefined ? window.settings.ticketAdditionalFilterOpen : settings.ExtraFilterToShowInAviaBooking;
                setTimeout(() => {
                    if (type === 1 && this.flexible && this.openDateTable) {
                        this.changeFilterType(type);
                            this.openDateTable = false
                    }
                },0);


                setTimeout(() => {
                    // const resetPrice = !this.$route.fullPath.includes('maxPrice') && !this.$route.fullPath.includes('minPrice');
                    this.setSecondFilters();
                    this.changeSecondFiltersOfUrl()
                    this.$nextTick(() => {
                      this.checkInputFilterValue(); // Обновляем данные в инпутах контекстного поиска
                    })
                },1000);
            });
            bus.$on("changeCurrency", (val) => {
                if (!val) return;

                this.convertPrice(val)
                    .then(res => {
                        const minPrice = res.data.m_Item1;
                        const maxPrice = res.data.m_Item2;
                        if (minPrice === 0 && maxPrice === 0) {
                            this.availabilityPrice[0] = null;
                            this.availabilityPrice[1] = null;
                            this.priceChange = false;
                            this.selectedFilters = this.selectedFilters.filter(x => x.Type !== 'price');
                            this.availabilityPrice.splice() //для реактивности Vue
                        } else {
                            this.availabilityPrice[0] = minPrice > 0 ? Math.ceil(minPrice) : '';
                            this.availabilityPrice[1] = maxPrice > 0 ? Math.ceil(maxPrice) : '';
                            this.availabilityPrice.splice() //для реактивности Vue
                        }

                        this.rate = JSON.parse(localStorage.getItem("Rate")) ? JSON.parse(localStorage.getItem("Rate")) : {};
                        bus.$emit('ticketsSearch', () => {
                            let data = this.$store.getters['tickets/getSecondaryFiltersResult'];
                            this.sendSecondFilterParams(false)
                                .then(() => {
                                    if (minPrice === 0 && maxPrice === 0) {
                                        this.availabilityPrice[0] = data.MinimalPrice;
                                        this.availabilityPrice[1] = data.MaximalPrice;
                                    }
                                    this.$nextTick(() => {
                                        this.ticketsPriceLimit = [
                                            data.MinimalPrice,
                                            data.MaximalPrice
                                        ];
                                        this.setDate(this.cashDate)
                                    })
                                })
                        });
                    })
            });
            bus.$on("localizeCode", () => {
                setTimeout(() => {
                    this.resize()
                }, 100)
            });
            bus.$on("tickets-searched", () => {
                this.$nextTick(() => {
                    this.directDOM = this.direct;

                    if (!this.flexible && this.filterType === 1) {
                        this.hide();
                    }
                })
            });
        },
        mounted() {
            if (this.flexible) {
                this.setDateTable();
            }

            this.directDOM = this.direct;

            this.rate = JSON.parse(localStorage.getItem("Rate")) ? JSON.parse(localStorage.getItem("Rate")) : {};
            this.localSecondFilters.price = this.ticketsPriceLimit.slice();
            this.setSecondFilters();
            this.getSettings();
            this.toggleSecondFiltersInfo();

            const settings = this.$store.getters['getSettings'];

            let type = window.settings.ticketAdditionalFilterOpen !== undefined ? window.settings.ticketAdditionalFilterOpen : settings.ExtraFilterToShowInAviaBooking;
            type = type < 4 && type > 0 ? type : null;

            if (type === 1 && this.flexible || type !== 1 && type) this.changeFilterType(type);
            else this.hide();

            const hasAviaQuota = location.href.split("&").find(x => x.includes("aviaQuota"));
            this.changeSecondFiltersOfUrl(false, hasAviaQuota);
        },
        methods: {
              checkInputFilterValue() {
                if (this.searchDeparture.length) {
                    this.ticketsDepartureList = this.ticketsDepartureList.map(x => {
                        if (!x.Name.toLowerCase().includes(this.searchDeparture.toLowerCase()) && !x.Code.toLowerCase().includes(this.searchDeparture.toLowerCase())) {
                            x.isShow = false
                        } else {
                            x.isShow = true
                        }

                        return x
                    })
                } else {
                    this.ticketsDepartureList = this.ticketsDepartureList.map(x => {
                        x.isShow = true;
                        return x
                    })
                }

                if (this.searchArrival.length) {
                    this.ticketsArrivalList = this.ticketsArrivalList.map(x => {
                        if (!x.Name.toLowerCase().includes(this.searchArrival.toLowerCase()) && !x.Code.toLowerCase().includes(this.searchArrival.toLowerCase())) {
                            x.isShow = false
                        } else {
                            x.isShow = true
                        }

                        return x
                    })
                } else {
                    this.ticketsArrivalList = this.ticketsArrivalList.map(x => {
                        x.isShow = true;
                        return x
                    })
                }

                if (this.searchAirline.length) {
                    this.ticketsAirlineList = this.ticketsAirlineList.map(x => {
                        if (!x.Name.toLowerCase().includes(this.searchAirline.toLowerCase())) {
                            x.isShow = false
                        } else {
                            x.isShow = true
                        }

                        return x
                    })
                } else {
                    this.ticketsAirlineList = this.ticketsAirlineList.map(x => {
                        x.isShow = true;
                        return x
                    })
                }
              },
              maskInputForNumber(event, range) {
              //разрешаем только ввода чисел
              let validNum = event.target.value.replace(/[^0-9]/g, "");
              //проверяем на допустимый диапазон
              if (validNum[0] === '0' && validNum.length > 1) {
                  event.target.value = '0'
              } else if (range !== 0 && validNum > range) {
                  event.target.value = range
              } else {
                  event.target.value = validNum
              }

              if (event.target.value !== '') {
                return +event.target.value
              } else {
                return event.target.value
              }
            },
            toggleSecondFiltersInfo() {
                const showFilterAlert = window.localStorage.getItem("showFilterAlertTickets");
                if (showFilterAlert === "false" || !this.$refs.filterIcon) return;

                const filterBtn = {
                    target: this.$refs.filterIcon
                }
                window.hideFilterAlert = () => {
                    this.hidePopover();
                    window.localStorage.setItem("showFilterAlertTickets", "false")
                }

                const content = `
                <div>
                    <p>${this.localizeList.additionalFilters}</p>
                    <span onclick="hideFilterAlert()" class="blue-text-small pointer">${this.localizeList.doNotShowAgain}</span>
                </div>
                `;

                this.showPopover( content, filterBtn, true);
                setTimeout(() => {
                    this.hidePopover();
                }, 5000)
            },
            toggleDateTable(val) {
                this.showDateTableForLeftFilters = val;

                const ticketsResult = document.querySelector(".tickets-result.vertical-filters");
                if (val) {
                    ticketsResult.classList.add("date-table-open")
                } else {
                    ticketsResult.classList.remove("date-table-open")
                }
            },
            changeTourPlace(key, typeTransport) {
                this.filterChange.push("ticketsPlace");
                this.setDefaultFilter(key, typeTransport);

                // this.changeSecondFilter('emptyPlace')
            },

            setDefaultFilter(key, typeTransport) {
                if (typeTransport == "aviaQuota") {
                    this.defaultAirFilter = this.defaultAirFilter.map((x) => {
                        x.isChecked = x.value === key;
                        return x
                    });
                    this.$store.commit("tickets/" + mTypesTickets.M_SET_AVIA_QUOTA_FOR_TICKETS, key)
                }
            },
            convertPrice(val) {
                return new Promise((resolve) => {
                    const data = {
                        keys: [...val],
                        price: [...this.availabilityPrice]
                    };
                    this.$store.dispatch('A_CONVERT_PRICE', data)
                        .then(res => {
                            resolve(res)
                        })
                })
            },
            getCurrencyDisplayBySettings(rate){
                return this.$store.getters['getCurrencyDisplayBySettings'](rate);
            },
            correctPrice(val, round = false) {
                if (round) {
                    val = Math.round(val)
                }
                const isFloat = val % 1 !== 0;
                let res = new Intl.NumberFormat().format(val);

                if (res.includes(".") || !isFloat) {
                    res = res.replace(/,/g, " ");
                } else {
                    res = res.replace(/,/g, ".");
                }
                res = (res.includes("NaN") || isNaN(parseInt(res))) ? "" : res;
                return res
            },
            resize() {
                this.setDoneBtnPosition();
                if (!this.$refs.airLineFilter) {
                    return
                }

                let padding = window.innerWidth > 1140 ? 60 : 20;
                let space = 10;
                const left = parseInt(this.$refs.airLineFilter.getBoundingClientRect().left) || 0;

                this.$refs.line2.style.right = `calc(100% - ${left - padding - space}px)`;
                this.$refs.line2.style.left = (left - padding - space - 1) + "px";
                this.$refs.line1.style.right = `calc(100% - ${left - padding - space}px)`;
            },
            scroll() {
                this.setDoneBtnPosition();
            },
            slideDate(to, index) {
                if (this.waitSlideDate) return;
                this.waitSlideDate = true;
                bus.$emit("tickets-slide-date-from", {
                    to,
                    index,
                    cb: () => {
                        this.$nextTick(() => {
                            this.waitSlideDate = false;
                        })
                    }
                })
            },
            setDate(item) {
                if (!item.cost)
                    return;

                this.cashDate = {...item};
                this.dateTableItems = this.dateTableItems.map((x, i) => {
                    x = x.map((x2, i2) => {
                        if (i === item.rowIndex && i2 === item.colIndex) {
                            x2.isChecked = true
                        } else {
                            x2.isChecked = false
                        }

                        return x2;
                    })

                    return x;
                });
                let filtredResult = this.getResultList.filter(x => {
                    if (x.DurationInNight === item.durationInNight) {
                        if (this.correctDate(x.StartDate) === item.from) {
                            return x;
                        }
                    }
                });
                this.$store.dispatch("tickets/A_SET_DATE", filtredResult)
            },
            worldDateFormat(date) {
                return date.split('.').join('/')
            },
            setDateTable(selectedDate = null) {
                if (!this.flexible || this.waitSlideDate) {
                    return;
                }

                this.initDateTable = true;
                let href = this.$route.fullPath;
                let dateFrom = null;
                let dateTo = null;
                href.split("&")
                    .forEach(x => {
                        if (x.includes("departureDate")) {
                            dateFrom = x.split("=")[1]
                        }
                        if (x.includes("returnDate")) {
                            dateTo = x.split("=")[1]
                        }
                    });

                let yearFrom = dateFrom.substr(0, 4);
                let monthFrom = dateFrom.substr(4, 2);
                let dayFrom = dateFrom.substr(6, 2);
                dateFrom = `${yearFrom}.${monthFrom}.${dayFrom}`;

                if (this.direct === 1) {
                    let yearTo = dateTo.substr(0, 4);
                    let monthTo = dateTo.substr(4, 2);
                    let dayTo = dateTo.substr(6, 2);
                    dateTo = `${yearTo}.${monthTo}.${dayTo}`;
                }

                this.dateTableHeader = [];
                this.dateTableItems = [];
                this.dateTableHeader.push("");
                for (let i = -3; i <= 3; i++) {
                    this.dateTableHeader.push({
                        text: moment(this.worldDateFormat(dateFrom)).add(i, 'days').format("DD MMM"),
                        value: moment(this.worldDateFormat(dateFrom)).add(i, 'days').format("YYYY.MM.DD")
                    });
                    let items = [];
                    if (this.direct === 1) {
                        items.push({
                            text: moment(this.worldDateFormat(dateTo)).add(i, 'days').format("DD MMM"),
                            value: moment(this.worldDateFormat(dateTo)).add(i, 'days').format("YYYY.MM.DD")
                        });
                        for (let j = 0; j < 7; j++) {
                            items.push({});
                        }
                        this.dateTableItems.push(items);
                    } else if (i === -3) {
                        for (let j = 0; j < 8; j++) {
                            items.push({});
                        }
                        this.dateTableItems.push(items);
                    }
                }

                let isSelected = false;
                this.getResultList.forEach(x => {
                    let fromD = this.correctDate(x.StartDate);
                    let toD = moment(this.worldDateFormat(fromD)).add(x.DurationInNight, 'days').format("YYYY.MM.DD");

                    let colIndex = this.dateTableHeader.map(x => x.value).indexOf(fromD);
                    let rowIndex = 0;
                    if (this.direct === 1) {
                        rowIndex = this.dateTableItems.map(x => x[0].value).indexOf(toD)
                    }

                    let cost = this.dateTableItems[rowIndex][colIndex]?.cost;
                    this.dateTableItems[rowIndex][colIndex].cost = cost ? (x.Cost < cost ? x.Cost : cost) : x.Cost;
                    this.dateTableItems[rowIndex][colIndex].rowIndex = rowIndex;
                    this.dateTableItems[rowIndex][colIndex].colIndex = colIndex;
                    this.dateTableItems[rowIndex][colIndex].from = fromD;
                    this.dateTableItems[rowIndex][colIndex].to = toD;
                    this.dateTableItems[rowIndex][colIndex].durationInNight = x.DurationInNight;
                    this.dateTableItems[rowIndex][colIndex].quotaColor = this.getAviaQuotaStatus(x);
                    this.dateTableItems[rowIndex][colIndex].isChecked = false;

                    if (selectedDate && !isSelected) {
                        this.setDate(selectedDate);
                        isSelected = true;
                    } else if (dateFrom === fromD && dateTo === toD) {
                        this.setDate(this.dateTableItems[rowIndex][colIndex])
                    } else if (dateFrom === fromD && dateTo === null) {
                        this.setDate(this.dateTableItems[rowIndex][colIndex])
                    }
                });
            },
            correctDate(item) {
                return moment(new Date(item.split("T")[0])).format("YYYY.MM.DD")
            },
            correctDayWord(day) {
                if (day == 1) {
                    return this.dayMode[0]
                } else if (day < 5) {
                    return this.dayMode[1]
                } else {
                    return this.dayMode[2]
                }
            },
            getSettings() {
                this.ticketsSettings = this.$store.getters['getSettings']
            },
            sendDateForm(date) {
                let correctDate = date.split("T")[0];
                return correctDate.split("-").reverse().join(".");
            },
            changeFilterType(type, global = false) {
                if (type === this.filterType || global && this.filterType) {
                    this.hide();
                    this.cashFilterType = "";
                } else {
                    this.cashFilterType = type;

                    this.focus = true;
                    this.filterType = type;
                    this.$nextTick(() => {
                        this.resize();
                    })
                }
            },
            setDoneBtnPosition() {
                const secondSearchBarList = document.querySelector(".second-search-bar-list");
                const btnGroup = document.querySelector(".btn-group");
                if (!btnGroup || !secondSearchBarList)
                    return;

                const secondSearchBarListTop = secondSearchBarList.getBoundingClientRect().top;

                const conditionForFixedFilters = secondSearchBarList.clientHeight < secondSearchBarList.scrollHeight;
                const conditionWithoutFixedFilters = secondSearchBarList.scrollHeight > window.innerHeight - secondSearchBarListTop;

                if ((this.fixedFilters && conditionForFixedFilters || !this.fixedFilters && conditionWithoutFixedFilters) && window.innerHeight > 300) {
                    btnGroup.classList.add("fixed");
                    const largeFilterOpened = this.filterType === 3;
                    if (largeFilterOpened) {
                        secondSearchBarList.style.paddingBottom = "95px";
                    }
                } else {
                    btnGroup.classList.remove("fixed");
                    secondSearchBarList.style.paddingBottom = "20px";
                }
            },
            resetLocalChanges() {
                this.changeSecondFiltersOfUrl(true);
                this.filtersChangeStatus = false;
                this.hide(true)
                this.pageLoaderCountStatus--;
            },
            hide() {
                this.focus = false;
                this.filterType = 0
            },
            changeSecondFiltersOfUrl(hide = false, ofSelectedFilters = false) {
                this.pageLoaderCountStatus++;
                let hasAdditionalParams = this.$route.fullPath.split("currency=")[1]?.includes("&");
                if (hide) {
                    if (!hasAdditionalParams) {
                        this.pageLoaderCountStatus--;
                        return new Promise(resolve => resolve(true))
                    }
                } else {
                    if (!hasAdditionalParams && !ofSelectedFilters) {
                        this.pageLoaderCountStatus--;
                        return new Promise(resolve => resolve(true))
                    }
                }

                this.filterChange = []
                // let data = this.$route.fullPath.split("currency=")[1].split("&");
                let data = this.$route.params.searchParams.split("&");
                let classT = false;
                let classMulty = false;
                let dTransfer = false;
                let aTransfer = false;
                let fTransfer = false;
                let fTransferArrival = false;
                let dAiraport = false;
                let aAiraport = false;
                let airline = false;
                let airlineMulty = false;
                data.forEach(x => {
                    if (x.includes("minPrice")) {
                        this.priceChange = true;
                        this.availabilityPrice = [
                            +(x.split("=")[1]),
                            this.availabilityPrice[1]
                        ]
                    }
                    const minPriceInclude = data.some(x2 => x2.includes("minPrice"))
                    if (!minPriceInclude) {
                        this.availabilityPrice = [
                            this.ticketsPriceLimit[0],
                            this.availabilityPrice[1]
                        ]
                    }
                    if (x.includes("maxPrice")) {
                        this.priceChange = true;
                        this.availabilityPrice = [
                            this.availabilityPrice[0],
                            +(x.split("=")[1])
                        ]
                    }
                    const maxPriceInclude = data.some(x2 => x2.includes("maxPrice"))
                    if (!maxPriceInclude) {
                        this.availabilityPrice = [
                            this.availabilityPrice[0],
                            this.ticketsPriceLimit[1]
                        ]
                    }
                    if (x.includes("aviaQuota")) {
                        this.setDefaultFilter(parseInt(x.split("=")[1]), "aviaQuota")
                    }
                    if (x.includes("tariff")) {
                        // Combo Tariff
                        // this.ticketsClassList.forEach(x2 => {
                        //     x2.forEach(x3 => {
                        //         let keys = x.split("=")[1].split(",");
                        //         this.$set(this.ticketsClassChecked, x3.Key, keys.includes(x3.Key + ""));
                        //         classT = true
                        //     });
                        // });
                        this.ticketsClassList.map(x2 => {
                            let keys = x.split("=")[1].split(",")
                            this.$set(this.ticketsClassChecked, x2.Key, keys.includes(x2.Key + ""));
                            classT = true
                        });
                    } else if (!classT) {
                        // Combo Tariff
                        // this.ticketsClassList.forEach(x2 => {
                        //     x2.forEach(x3 => {
                        //         this.$set(this.ticketsClassChecked, x3.Key, false);
                        //     })
                        // });
                        this.ticketsClassList.map(x2 => {
                            this.$set(this.ticketsClassChecked, x2.Key, false);
                        });
                    }
                    if (x.includes("combineTariffs")) {
                        this.ticketsClassMulty.isChecked = true
                        classMulty = true
                    } else if (!classMulty) {
                        this.ticketsClassMulty.isChecked = false
                    }
                    if (x.includes("departureFlightNoTransfer")) {
                        this.ticketsTransplantationList[0].isChecked = true
                        dTransfer = true
                    } else if (!dTransfer) {
                        this.ticketsTransplantationList[0].isChecked = false
                    }
                    if (x.includes("arrivalFlightNoTransfer")) {
                        this.ticketsTransplantationListTo[0].isChecked = true
                        aTransfer = true
                    } else if (!aTransfer) {
                        this.ticketsTransplantationListTo[0].isChecked = false
                    }
                    if (x.includes("departureFlightNumberTransfer")) {
                        let numb = x.split("=")[1];
                        this.ticketsTransplantationList[1].isChecked = numb == 1 || numb == 3;
                        this.ticketsTransplantationList[2].isChecked = numb == 2 || numb == 3;
                        fTransfer = true
                    } else if (!fTransfer) {
                        this.ticketsTransplantationList[1].isChecked = false;
                        this.ticketsTransplantationList[2].isChecked = false;
                    }
                    if (x.includes("arrivalFlightNumberTransfer")) {
                        let numb = x.split("=")[1];
                        this.ticketsTransplantationListTo[1].isChecked = numb == 1 || numb == 3;
                        this.ticketsTransplantationListTo[2].isChecked = numb == 2 || numb == 3;
                        fTransferArrival = true
                    } else if (!fTransferArrival) {
                        this.ticketsTransplantationListTo[1].isChecked = false;
                        this.ticketsTransplantationListTo[2].isChecked = false;
                    }
                    if (x.includes("airportDeparture")) {
                        this.ticketsDepartureList.map(x2 => {
                            let keys = x.split("=")[1].split(",")
                            this.$set(this.ticketsDepartureAirportsChecked, x2.Key, keys.includes(x2.Code));
                            dAiraport = true
                        });
                    } else if (!dAiraport) {
                        this.ticketsDepartureList.map(x2 => {
                            this.$set(this.ticketsDepartureAirportsChecked, x2.Key, false);
                        });
                    }
                    if (x.includes("airportArrival")) {
                        this.ticketsArrivalList.map(x2 => {
                            let keys = x.split("=")[1].split(",")
                            this.$set(this.ticketsArrivalAirportsChecked, x2.Key, keys.includes(x2.Code));
                            aAiraport = true
                        });
                    } else if (!aAiraport) {
                        this.ticketsArrivalList.map(x2 => {
                            this.$set(this.ticketsArrivalAirportsChecked, x2.Key, false);
                        });
                    }
                    if (x.includes("airlines")) {
                        this.ticketsAirlineList.map(x2 => {
                            let keys = x.split("=")[1].split(",")
                            this.$set(this.ticketsAirlinesChecked, x2.Key, keys.includes(x2.Code));
                            airline = true
                        });
                    } else if (!airline) {
                        this.ticketsAirlineList.map(x2 => {
                            this.$set(this.ticketsAirlinesChecked, x2.Key, false);
                        });
                    }
                    if (x.includes("combineAirlines")) {
                        this.ticketsAirlineMulty.isChecked = true
                        airlineMulty = true
                    } else if (!airlineMulty) {
                        this.ticketsAirlineMulty.isChecked = false
                    }
                    if (x.includes("timeDepartureFrom")) {
                        let time = x.split("=")[1];
                        this.departureTime = [
                            this.timeToMinuts(time),
                            +this.departureTime[1]
                        ];
                        this.dTimeChange = true;
                    }
                    const depTimeFromInclude = data.some(x2 => x2.includes("timeDepartureFrom"));
                    if (!depTimeFromInclude) {
                        this.departureTime = [
                            0,
                            this.departureTime[1]
                        ]
                    }
                    if (x.includes("timeDepartureTo")) {
                        let time = x.split("=")[1];
                        this.departureTime = [
                            +this.departureTime[0],
                            this.timeToMinuts(time)
                        ];
                        this.dTimeChange = true;
                    }
                    const depTimeToInclude = data.some(x2 => x2.includes("timeDepartureTo"));
                    if (!depTimeToInclude) {
                        this.departureTime = [
                            this.departureTime[0],
                            1439
                        ]
                    }
                    if (x.includes("timeArrivalFrom")) {
                        let time = x.split("=")[1];
                        this.arrivalTime = [
                            this.timeToMinuts(time),
                            +this.arrivalTime[1]
                        ];
                        this.aTimeChange = true;
                    }
                    const arrTimeFromInclude = data.some(x2 => x2.includes("timeArrivalFrom"));
                    if (!arrTimeFromInclude) {
                        this.arrivalTime = [
                            0,
                            this.arrivalTime[1]
                        ]
                    }
                    if (x.includes("timeArrivalTo")) {
                        let time = x.split("=")[1];
                        this.arrivalTime = [
                            +this.arrivalTime[0],
                            this.timeToMinuts(time)
                        ];
                        this.aTimeChange = true;
                    }
                    const arrTimeToInclude = data.some(x2 => x2.includes("timeArrivalTo"));
                    if (!arrTimeToInclude) {
                        this.arrivalTime = [
                            this.arrivalTime[0],
                            1439
                        ]
                    }
                });
                let changeParams = {
                    price: this.availabilityPrice,
                    classMulty: this.ticketsClassMulty.isChecked,
                    airlinesMulty: false,
                    dTime: [
                        this.minutsToTime(this.departureTime[0]),
                        this.minutsToTime(this.departureTime[1])
                    ],
                    aTime: [
                        this.minutsToTime(this.arrivalTime[0]),
                        this.minutsToTime(this.arrivalTime[1])
                    ],
                }
                return new Promise((resolve) => {
                    this.changeSecondFilter("changeAll", null, changeParams, true).then(() => {
                        if (!hide) {
                            this.sendSecondFilterParams(false).then(() => {
                                this.pageLoaderCountStatus--;
                                resolve(true)
                            });
                        } else {
                            this.pageLoaderCountStatus--;
                            this.filtersChangeStatus = false
                        }
                    })
                });
            },
            clearAllFilters(clientClick = false) {
                this.filterChange = [];
                this.selectedFilters = [];

                this.availabilityPrice = [...this.ticketsPriceLimit];
                this.priceChange = false;
                this.ticketsClassList = this.ticketsClassList.map(x => {
                    // Combo Tariff
                    // return x.map(x2 => {
                    //     this.$set(this.ticketsClassChecked, x2.Key, false);
                    //     x2.isDisabled = false;
                    //     return x2
                    // });
                    this.$set(this.ticketsClassChecked, x.Key, false);
                    x.isDisabled = false
                    return x
                });
                this.ticketsClassMulty.isChecked = false;
                this.ticketsTransplantationList = this.ticketsTransplantationList.map(x => {
                    x.isChecked = false;
                    x.isDisabled = false
                    return x
                });
                this.ticketsTransplantationListTo = this.ticketsTransplantationListTo.map(x => {
                    x.isChecked = false;
                    x.isDisabled = false
                    return x
                });
                this.ticketsDepartureList = this.ticketsDepartureList.map(x => {
                    this.$set(this.ticketsDepartureAirportsChecked, x.Key, false);
                    x.isDisabled = false
                    return x
                });
                this.ticketsArrivalList = this.ticketsArrivalList.map(x => {
                    this.$set(this.ticketsArrivalAirportsChecked, x.Key, false);
                    x.isDisabled = false
                    return x
                });
                this.ticketsAirlineList = this.ticketsAirlineList.map(x => {
                    this.$set(this.ticketsAirlinesChecked, x.Key, false);
                    x.isDisabled = false
                    return x
                });
                this.ticketsAirlineMulty.isChecked = false;
                this.departureTime = [0, 1439];
                this.arrivalTime = [0, 1439];
                this.dTimeChange = false;
                this.aTimeChange = false;
                this.localSecondFilters = {
                    price: [0, 100000],
                    aviaQuota: 7,
                    ticketsClass: [],
                    ticketsClassMulty: false,
                    ticketsTransplantation: [],
                    ticketsTransplantationTo: [],
                    ticketsDepartureAirports: [],
                    ticketsArrivalAirports: [],
                    ticketsAirlines: [],
                    ticketsAirlinesMulty: false,
                    departureTime: ["00:00", "23:59"],
                    arrivalTime: ["00:00", "23:59"],
                };

                if (clientClick) this.clearAllSearchInput()

                this.sendSecondFilterParams(false);
            },
            sendSecondFilterParams(hide = true, cb = null) {
                this.loaderStatus = true;
                this.filtersChangeStatus = false;

                if (this.availabilityPrice[0] > this.availabilityPrice[1] && this.availabilityPrice[1]) {
                    this.availabilityPrice[0] = this.availabilityPrice[1];
                }

                let minPrice = this.priceChange ? this.availabilityPrice[0] : null;
                let maxPrice = this.priceChange ? this.availabilityPrice[1] : null;
                if (this.priceChange) {
                    const [min, max] = this.availabilityPrice;
                    let validName = ''
                    if (min && max) {
                      validName = `${this.localizeList.priceUpper}: ${this.localizeList.from} ${this.correctPrice(min, true)} ${this.getCurrencyDisplayBySettings(this.rate)} ${this.localizeList.to} ${this.correctPrice(max, true)} ${this.getCurrencyDisplayBySettings(this.rate)}`
                    } else if (min && !max) {
                      validName = `${this.localizeList.priceUpper}: ${this.localizeList.from} ${this.correctPrice(min, true)} ${this.getCurrencyDisplayBySettings(this.rate)}`
                    } else if  (!min && max) {
                      validName = `${this.localizeList.priceUpper}: ${this.localizeList.to} ${this.correctPrice(max, true)} ${this.getCurrencyDisplayBySettings(this.rate)}`
                    }
                    const price = {
                        Type: "price",
                        Name: validName,
                        items: this.availabilityPrice
                    };
                    let key = this.selectedFilters.map(x => x.Type).indexOf(price.Type);
                    if (key === -1 && price.Name) {
                        this.selectedFilters.push(price)
                    } else if (key !== -1 && !price.Name) {
                     this.selectedFilters.splice(key, 1)
                    } else {
                      this.selectedFilters = this.selectedFilters.map((x, i) => {
                        if (key === i) {
                          return price
                        }
                        return x
                      })
                    }
                }
                // let ticketsClass = this.ticketsClassList.flat(1).filter((x) => { //Combo Tariff
                let ticketsClass = this.ticketsClassList.filter((x) => {
                    if (this.ticketsClassChecked[x.Key]) {
                        if (!this.selectedFilters.includes(x))
                            this.selectedFilters.push(x);
                        return x
                    } else {
                        this.selectedFilters = this.selectedFilters.filter(x2 => {
                            if (x2.Type !== "AirService" || this.ticketsClassChecked[x2.Key]){
                                return x2
                            }
                        })
                    }
                });
                let ticketsClassMulty = this.ticketsClassMulty.isChecked;
                let ticketsTransplantation = this.ticketsTransplantationList.filter((x, i) => {
                    if (this.ticketsTransplantationList[i].isChecked) {
                        const item = {...x};
                        item.Type = `Transplantation_${i}`;
                        item.Name = this.localizeList[item.label] +" "+ this.localizeList.forward.toLowerCase();
                        if (!this.selectedFilters.map(x => x.Type).includes(item.Type))
                            this.selectedFilters.push(item);
                        return x
                    } else {
                        this.selectedFilters = this.selectedFilters.filter(x2 => {
                            if (x2.Type !== `Transplantation_${i}` || this.ticketsTransplantationList[i].isChecked){
                                return x2
                            }
                        })
                    }
                });
                let ticketsTransplantationArrival = this.ticketsTransplantationListTo.filter((x, i) => {
                    if (this.ticketsTransplantationListTo[i].isChecked) {
                        const item = {...x};
                        item.Type = `Transplantation_${i}_a`;
                        item.Name = this.localizeList[item.label] +" "+ this.localizeList.backward.toLowerCase();
                        if (!this.selectedFilters.map(x => x.Type).includes(item.Type))
                            this.selectedFilters.push(item);
                        return x
                    } else {
                        this.selectedFilters = this.selectedFilters.filter(x2 => {
                            if (x2.Type !== `Transplantation_${i}_a` || this.ticketsTransplantationListTo[i].isChecked){
                                return x2
                            }
                        })
                    }
                });
                let ticketsDepartureAirports = this.ticketsDepartureList.filter((x) => {
                    if (this.ticketsDepartureAirportsChecked[x.Key]) {
                        if (!this.selectedFilters.includes(x))
                            this.selectedFilters.push(x);
                        return x
                    } else {
                        this.selectedFilters = this.selectedFilters.filter(x2 => {
                            if (x2.Type !== "Airport" || this.ticketsDepartureAirportsChecked[x2.Key]){
                                return x2
                            }
                        })
                    }
                });
                let ticketsArrivalAirports = this.ticketsArrivalList.filter((x) => {
                    if (this.ticketsArrivalAirportsChecked[x.Key]) {
                        x = {...x};
                        x.Type = "aAirport";
                        if (!this.selectedFilters.map(x2 => x2.Name+""+x2.Type).includes(x.Name+""+x.Type))
                            this.selectedFilters.push(x);
                        return x
                    } else {
                        this.selectedFilters = this.selectedFilters.filter(x2 => {
                            if (x2.Type !== "aAirport" || this.ticketsArrivalAirportsChecked[x2.Key]){
                                return x2
                            }
                        })
                    }
                });
                let ticketsAirlines = this.ticketsAirlineList.filter((x) => {
                    if (this.ticketsAirlinesChecked[x.Key]) {
                        x.Type = "AirLine";
                        if (!this.selectedFilters.includes(x)) {
                            this.selectedFilters.push(x);
                        }
                        return x
                    } else {
                        this.selectedFilters = this.selectedFilters.filter(x2 => {
                            if (x2.Type !== "AirLine" || this.ticketsAirlinesChecked[x2.Key]){
                                return x2
                            }
                        })
                    }
                });
                let ticketsAirlineMulty = this.ticketsAirlineMulty.isChecked
                let departureTime = [];
                if (this.dTimeChange) {
                    departureTime = [
                        this.minutsToTime(this.departureTime[0]),
                        this.minutsToTime(this.departureTime[1])
                    ];
                    const time = {
                        Type: "dTime",
                        Name: `${this.localizeList.departureUpper} ${this.minutsToTime(this.departureTime[0])} – ${this.minutsToTime(this.departureTime[1])}`,
                        items: this.departureTime
                    };
                    let key = this.selectedFilters.map(x => x.Type).indexOf(time.Type);
                    if (key === -1) {
                        this.selectedFilters.push(time);
                    } else {
                        this.selectedFilters = this.selectedFilters.map((x, i) => {
                            if (key === i) {
                                return time
                            }
                            return x
                        })
                    }
                }
                let arrivalTime = [];
                if (this.aTimeChange) {
                    arrivalTime = [
                        this.minutsToTime(this.arrivalTime[0]),
                        this.minutsToTime(this.arrivalTime[1])
                    ];
                    const time = {
                        Type: "aTime",
                        Name: `${this.localizeList.arrivalUpper} ${this.minutsToTime(this.arrivalTime[0])} – ${this.minutsToTime(this.arrivalTime[1])}`,
                        items: this.arrivalTime
                    };
                    let key = this.selectedFilters.map(x => x.Type).indexOf(time.Type);
                    if (key === -1) {
                        this.selectedFilters.push(time);
                    } else {
                        this.selectedFilters = this.selectedFilters.map((x, i) => {
                            if (key === i) {
                                return time
                            }
                            return x
                        })
                    }
                }

                const aviaQuota = this.getAviaQuota;

                return new Promise((resolve) => {
                    this.$store.dispatch("tickets/A_SET_SEARCH_SECOND_PARAMS", {
                        minPrice,
                        maxPrice,
                        ticketsClass,
                        ticketsClassMulty,
                        ticketsTransplantation,
                        ticketsTransplantationArrival,
                        ticketsDepartureAirports,
                        ticketsArrivalAirports,
                        ticketsAirlines,
                        ticketsAirlineMulty,
                        departureTime,
                        arrivalTime,
                        aviaQuota
                    }).then(res => {
                        this.$nextTick(() => {
                          this.checkInputFilterValue(); // Обновляем данные в инпутах контекстного поиска
                        })

                        let newUrl = res.replace("?", "/");

                        const isTickets = this.$route.fullPath.includes("Individuals/Avia");
                        if (this.$route.fullPath !== "/Individuals/Avia" + newUrl && isTickets){
                            this.$router.push("/Individuals/Avia" + newUrl)
                        }
                        if (!isTickets) {
                            this.cashUrl = '/Individuals/Avia' + newUrl
                        }

                        // this.clearAllSearchInput()

                        this.loaderStatus = false;
                        if (hide) {
                            this.hide();
                            this.isClickApply = true;
                        }
                        // this.setSecondFilters();
                        if (cb) cb();

                        resolve(true)
                    })
                })
            },
            disabledSecondFilters() {
                let data = this.$store.getters['tickets/getSecondaryFiltersResult'];

                this.ticketsClassList = this.ticketsClassList.map((x) => {
                    // Combo Tariff
                    // return x.map(x2 => {
                    //     let isIncludes = data.FlightTariffs.map(x3 => x3.Key).includes(x2.Key);
                    //     x2.isDisabled = !isIncludes && !this.ticketsClassChecked[x2.Key];
                    //
                    //     return x2
                    // });
                    let isIncludes = data.FlightTariffs.map(x2 => x2.Key).includes(x.Key)
                    if (!isIncludes && !this.ticketsClassChecked[x.Key]) {
                        x.isDisabled = true
                    } else {
                        x.isDisabled = false
                    }
                    return x

                });

                if (!this.filterChange.includes("ticketsDepartureAirports")) {
                    this.ticketsDepartureList = this.ticketsDepartureList.map((x) => {
                        let isIncludes = data.DepartureAirports.map(x2 => x2.Key).includes(x.Key)
                        if (!isIncludes && !this.ticketsDepartureAirportsChecked[x.Key]) {
                            x.isDisabled = true
                        } else {
                            x.isDisabled = false
                        }
                        return x
                    });
                }

                if (!this.filterChange.includes("ticketsArrivalAirports")) {
                    this.ticketsArrivalList = this.ticketsArrivalList.map((x) => {
                        let isIncludes = data.ArrivalAirports.map(x2 => x2.Key).includes(x.Key)
                        if (!isIncludes && !this.ticketsArrivalAirportsChecked[x.Key]) {
                            x.isDisabled = true
                        } else {
                            x.isDisabled = false
                        }
                        return x
                    });
                }

                if (!this.filterChange.includes("ticketsAirlines")) {
                    this.ticketsAirlineList = this.ticketsAirlineList.map((x) => {
                        let isIncludes = data.Airlines.map(x2 => x2.Key).includes(x.Key)
                        if (!isIncludes && !this.ticketsAirlinesChecked[x.Key]) {
                            x.isDisabled = true
                        } else {
                            x.isDisabled = false
                        }
                        return x
                    });
                }
            },
            removePrice(price = null) {
                let params = this.$route.fullPath.split("&");
                params = params.map(x => {
                    if (!price && (x.includes("minPrice") || x.includes("maxPrice"))) {
                        return null
                    } else if (price && x.includes("minPrice")) {
                        return `minPrice=${price[0]}`
                    } else if (price && x.includes("maxPrice")) {
                        return `maxPrice=${price[1]}`
                    } else {
                        return x
                    }
                }).filter(x => x);

                params = params.join("&");
                if (this.$route.fullPath !== params)
                    this.$router.push(params);
            },
            // setSecondFilters(resetPrice = true) {
            setSecondFilters() {
                let data = this.$store.getters['tickets/getSecondaryFiltersResult'];

                // if (resetPrice) {
                //     this.availabilityPrice = [
                //         data.MinimalPrice,
                //         data.MaximalPrice
                //     ];
                // }

                // this.ticketsPriceLimit = [
                //     data.MinimalPrice,
                //     data.MaximalPrice
                // ];

                // if (this.availabilityPrice[0] < this.ticketsPriceLimit[0] || this.availabilityPrice[1] > this.ticketsPriceLimit[1]) {
                //     this.removePrice();
                //     bus.$emit('removeTicketPrice');
                //
                //     this.availabilityPrice[0] = this.ticketsPriceLimit[0];
                //     this.availabilityPrice[1] = this.ticketsPriceLimit[1];
                // }

                if (
                    this.availabilityPrice[0] < this.ticketsPriceLimit[0] && this.availabilityPrice[1] > this.ticketsPriceLimit[1] ||
                    this.availabilityPrice[0] > this.ticketsPriceLimit[1] || this.availabilityPrice[1] < this.ticketsPriceLimit[0]
                ) {
                    this.removePrice();

                    this.availabilityPrice[0] = this.ticketsPriceLimit[0];
                    this.availabilityPrice[1] = this.ticketsPriceLimit[1];
                    this.sendSecondFilterParams()
                } else if (this.availabilityPrice[0] < this.ticketsPriceLimit[0]) {
                    this.removePrice([this.ticketsPriceLimit[0], this.availabilityPrice[1]]);

                    this.availabilityPrice[0] = this.ticketsPriceLimit[0];
                    this.sendSecondFilterParams()
                } else if (this.availabilityPrice[1] > this.ticketsPriceLimit[1]) {
                    this.removePrice([this.availabilityPrice[0], this.ticketsPriceLimit[1]]);

                    this.availabilityPrice[1] = this.ticketsPriceLimit[1];
                    this.sendSecondFilterParams()
                }

                // Combo Tariff
                // const cashClassNames = [];
                // const ticketsClassList = [];
                // this.$store.getters['quicksort'](data.FlightTariffs, "Name").forEach((x) => {
                //     this.$set(this.ticketsClassChecked, x.Key, false);
                //     const index = cashClassNames.indexOf(x.Name);
                //     if (index === -1) {
                //         cashClassNames.push(x.Name);
                //         ticketsClassList.push([x])
                //     } else {
                //         ticketsClassList[index].push(x);
                //     }
                //
                // });
                // this.ticketsClassList = [...ticketsClassList];
                this.ticketsClassList = this.$store.getters['quicksort'](data.FlightTariffs, "Name").map((x) => {
                    if (!Object.keys(this.ticketsClassChecked).length) {
                        this.$set(this.ticketsClassChecked, x.Key, false)
                    }
                    return x
                });

                this.ticketsDepartureList = this.$store.getters['quicksort'](data.DepartureAirports, "Name").map((x) => {
                    x.isShow = true;
                    if (!Object.keys(this.ticketsDepartureAirportsChecked).length) {
                        this.$set(this.ticketsDepartureAirportsChecked, x.Key, false)
                    }
                    return x
                });

                this.ticketsArrivalList = this.$store.getters['quicksort'](data.ArrivalAirports, "Name").map((x) => {
                    x.isShow = true;
                    if (!Object.keys(this.ticketsArrivalAirportsChecked).length) {
                        this.$set(this.ticketsArrivalAirportsChecked, x.Key, false)
                    }
                    return x
                });

                this.ticketsAirlineList = this.$store.getters['quicksort'](data.Airlines, "Name").map((x) => {
                    x.isShow = true;
                    if (!Object.keys(this.ticketsAirlinesChecked).length) {
                        this.$set(this.ticketsAirlinesChecked, x.Key, false)
                    }
                    return x
                });
            },
            changeSecondFilter(type, val, allParams, sendRequest = true) {
                switch (type) {
                    case "price":
                        this.localSecondFilters.price = val.slice()
                        break;
                    case "emptyPlace":
                        this.localSecondFilters.aviaQuota = this.defaultAirFilter.find(x => x.isChecked).value;
                        break;
                    case "ticketsClass":
                        // this.localSecondFilters.ticketsClass = this.ticketsClassList.flat(1).filter((x) => { //Combo Tariff
                        this.localSecondFilters.ticketsClass = this.ticketsClassList.filter((x) => {
                            if (this.ticketsClassChecked[x.Key]) {
                                return x
                            }
                        })
                        break;
                    case "ticketsClassMulty":
                        this.localSecondFilters.ticketsClassMulty = val
                        break;
                    case "ticketsTransplantation":
                        this.localSecondFilters.ticketsTransplantation = this.ticketsTransplantationList.filter((x) => {
                            if (x.isChecked) {
                                return x
                            }
                        })
                        break;
                    case "ticketsTransplantationTo":
                        this.localSecondFilters.ticketsTransplantationTo = this.ticketsTransplantationListTo.filter((x) => {
                            if (x.isChecked) {
                                return x
                            }
                        })
                        break;
                    case "ticketsDepartureAirports":
                        this.localSecondFilters.ticketsDepartureAirports = this.ticketsDepartureList.filter((x) => {
                            if (this.ticketsDepartureAirportsChecked[x.Key]) {
                                return x
                            }
                        })
                        break;
                    case "ticketsArrivalAirports":
                        this.localSecondFilters.ticketsArrivalAirports = this.ticketsArrivalList.filter((x) => {
                            if (this.ticketsArrivalAirportsChecked[x.Key]) {
                                return x
                            }
                        })
                        break;
                    case "ticketsAirlines":
                        this.localSecondFilters.ticketsAirlines = this.ticketsAirlineList.filter((x) => {
                            if (this.ticketsAirlinesChecked[x.Key]) {
                                return x
                            }
                        })
                        break;
                    case "ticketsAirlinesMulty":
                        this.localSecondFilters.ticketsAirlinesMulty = val
                        break;
                    case "departureTime":
                        this.localSecondFilters.departureTime = val.slice()
                        break;
                    case "arrivalTime":
                        this.localSecondFilters.arrivalTime = val.slice()
                        break;
                    case "changeAll":
                        this.localSecondFilters.price = this.priceChange ? allParams.price.slice() : [];
                        this.filterChange.push("ticketsPrice");
                        this.filterChange.push("ticketsPlace");
                        // this.localSecondFilters.ticketsClass = this.ticketsClassList.flat(1).filter((x) => { // Combo Tariff
                        this.localSecondFilters.ticketsClass = this.ticketsClassList.filter((x) => {
                            if (this.ticketsClassChecked[x.Key]) {
                                return x
                            }
                        });
                        this.localSecondFilters.ticketsClass.length ? this.filterChange.push("ticketsClass") : null;
                        this.localSecondFilters.ticketsClassMulty = allParams.classMulty;
                        this.filterChange.push("classMulty")
                        this.localSecondFilters.ticketsTransplantation = this.ticketsTransplantationList.filter((x) => {
                            if (x.isChecked) {
                                return x
                            }
                        });
                        this.localSecondFilters.ticketsTransplantationTo = this.ticketsTransplantationListTo.filter((x) => {
                            if (x.isChecked) {
                                return x
                            }
                        });
                        this.localSecondFilters.ticketsTransplantation.length ? this.filterChange.push("ticketsTransplantation") : null;
                        this.localSecondFilters.ticketsTransplantationTo.length ? this.filterChange.push("ticketsTransplantationTo") : null;
                        this.localSecondFilters.ticketsDepartureAirports = this.ticketsDepartureList.filter((x) => {
                            if (this.ticketsDepartureAirportsChecked[x.Key]) {
                                return x
                            }
                        });
                        this.localSecondFilters.ticketsDepartureAirports.length ? this.filterChange.push("ticketsDepartureAirports") : null;
                        this.localSecondFilters.ticketsArrivalAirports = this.ticketsArrivalList.filter((x) => {
                            if (this.ticketsArrivalAirportsChecked[x.Key]) {
                                return x
                            }
                        });
                        this.localSecondFilters.ticketsArrivalAirports.length ? this.filterChange.push("ticketsArrivalAirports") : null;
                        this.localSecondFilters.ticketsAirlines = this.ticketsAirlineList.filter((x) => {
                            if (this.ticketsAirlinesChecked[x.Key]) {
                                return x
                            }
                        });
                        this.localSecondFilters.ticketsAirlines.length ? this.filterChange.push("ticketsAirlines") : null;
                        this.localSecondFilters.ticketsAirlinesMulty = allParams.airlinesMulty;
                        this.filterChange.push("ticketsAirlinesMulty");
                        this.localSecondFilters.departureTime = allParams.dTime.slice();
                        if (this.localSecondFilters.departureTime[0] !== this.minutsToTime(this.departureTime[0]) ||
                            this.localSecondFilters.departureTime[1] !== this.minutsToTime(this.departureTime[1])) {
                            this.dTimeChange = true
                        }
                        this.filterChange.push("departureTime");
                        this.localSecondFilters.arrivalTime = allParams.aTime.slice();
                        if (this.localSecondFilters.arrivalTime[0] !== this.minutsToTime(this.arrivalTime[0]) ||
                            this.localSecondFilters.arrivalTime[1] !== this.minutsToTime(this.arrivalTime[1])) {
                            this.aTimeChange = true
                        }
                        this.filterChange.push("arrivalTime");
                        break;
                }
                this.localSecondFilters.price = this.priceChange ? this.localSecondFilters.price : [];

                return new Promise(resolve => {
                    if (sendRequest) {
                        if (!this.settings.UseApplyFiltersButton) {
                            this.sendSecondFilterParams(false)
                        }
                        resolve(true)
                    } else {
                        this.loaderStatus = false;
                        resolve(true)
                    }
                })
            },
            changePrice(e, change = false) {
                if (change) {
                    this.availabilityPrice = [...e];
                }
                this.priceChange = true;
                this.filterChange.push("ticketsPrice");
                this.changeSecondFilter('price', e);
            },
            // Combo Tariff
            // changeTicketClass(arr, val) {
            //     arr.forEach(x => {
            //         this.ticketsClassChecked[x.Key] = val;
            //         let isSomeChecked = Object.values(this.ticketsClassChecked).some(x2 => x2);
            //         if (isSomeChecked) {
            //             if (!this.filterChange.includes("ticketsClass")) {
            //                 this.filterChange.push("ticketsClass");
            //             }
            //         } else {
            //             this.filterChange = this.filterChange.filter(x2 => x2 !== "ticketsClass")
            //         }
            //
            //     });
            //     this.changeSecondFilter('ticketsClass')
            // },
            changeTourClass(index, val) {
                this.ticketsClassChecked[index] = val;
                let isSomeChecked = Object.values(this.ticketsClassChecked).some(x => x);
                if (isSomeChecked) {
                    if (!this.filterChange.includes("ticketsClass")) {
                        this.filterChange.push("ticketsClass");
                    }
                } else {
                    this.filterChange = this.filterChange.filter(x => x !== "ticketsClass")
                }

                this.changeSecondFilter('ticketsClass')
            },
            // changeTicketClassMulty(val) { // Combo Tariff
            changeTourClassMulty(val) {
                this.filterChange.push("ticketsClassMulty");
                this.ticketsClassMulty.isChecked = val;
                this.changeSecondFilter('ticketsClassMulty', val)
            },
            changeTourTransplantation(index, val) {
                this.filterChange.push("ticketsTransplantation");
                this.ticketsTransplantationList[index].isChecked = val;
                this.changeSecondFilter('ticketsTransplantation')
            },
            changeTourTransplantationTo(index, val) {
                this.filterChange.push("ticketsTransplantationTo");
                this.ticketsTransplantationListTo[index].isChecked = val;
                this.changeSecondFilter('ticketsTransplantationTo')
            },
            changeTourDepartureAirports(index, val) {
                this.ticketsDepartureAirportsChecked[index] = val;
                let isSomeChecked = Object.values(this.ticketsDepartureAirportsChecked).some(x => x);
                if (isSomeChecked) {
                    if (!this.filterChange.includes("ticketsDepartureAirports")) {
                        this.filterChange.push("ticketsDepartureAirports");
                    }
                } else {
                    this.filterChange = this.filterChange.filter(x => x !== "ticketsDepartureAirports")
                }
                this.changeSecondFilter('ticketsDepartureAirports')
            },
            changeTourArrivalAirports(index, val) {
                this.ticketsArrivalAirportsChecked[index] = val;
                let isSomeChecked = Object.values(this.ticketsArrivalAirportsChecked).some(x => x);
                if (isSomeChecked) {
                    if (!this.filterChange.includes("ticketsArrivalAirports")) {
                        this.filterChange.push("ticketsArrivalAirports");
                    }
                } else {
                    this.filterChange = this.filterChange.filter(x => x !== "ticketsArrivalAirports")
                }
                this.changeSecondFilter('ticketsArrivalAirports')
            },
            changeTourAirlines(index, val) {
                this.ticketsAirlinesChecked[index] = val;
                let isSomeChecked = Object.values(this.ticketsAirlinesChecked).some(x => x);
                if (isSomeChecked) {
                    if (!this.filterChange.includes("ticketsAirlines")) {
                        this.filterChange.push("ticketsAirlines");
                    }
                } else {
                    this.filterChange = this.filterChange.filter(x => x !== "ticketsAirlines")
                }
                this.changeSecondFilter('ticketsAirlines')
            },
            changeTourAirlineMulty(val) {
                this.filterChange.push("ticketsAirlinesMulty");
                this.ticketsAirlineMulty.isChecked = val;
                this.changeSecondFilter('ticketsAirlinesMulty', val)
            },
            changeDepartureTime(val, change = false) {
                if (change) this.departureTime = [...val];

                this.dTimeChange = true;
                this.filterChange.push("departureTime");
                this.changeSecondFilter('departureTime', [
                    this.minutsToTime(val[0]),
                    this.minutsToTime(val[1])
                ])
            },
            changeArrivalTime(val, change = false) {
                if (change) this.arrivalTime = [...val];

                this.aTimeChange = true;
                this.filterChange.push("arrivalTime");
                this.changeSecondFilter('arrivalTime', [
                    this.minutsToTime(val[0]),
                    this.minutsToTime(val[1])
                ])
            },
            getAviaQuotaStatus(item) {
                let aviaQuota = 3;
                item.Services.forEach(x => {
                    if (x.FlightDetails && x.FlightDetails[0].QuotaStatus.PlacesStatus === 4) {
                        aviaQuota = 0
                    } else if (x.FlightDetails && x.FlightDetails[0].QuotaStatus.PlacesStatus === 1 && x.FlightDetails[0].QuotaStatus.FreePlaces > 0) {
                        if (aviaQuota > 0) {
                            aviaQuota = 1
                        }
                    } else if (x.FlightDetails && x.FlightDetails[0].QuotaStatus.PlacesStatus === 1 && x.FlightDetails[0].QuotaStatus.FreePlaces === 0) {
                        if (aviaQuota > 1) {
                            aviaQuota = 2
                        }
                    }else if (x.FlightDetails && x.FlightDetails[0].QuotaStatus.PlacesStatus === 2) {
                        if (aviaQuota == 3) {
                            aviaQuota = 3
                        }
                    }
                });
                if (aviaQuota === 2) {
                    return "#4ACA7F"
                } else if (aviaQuota === 1) {
                    return "var(--primary-color)"
                } else if (aviaQuota === 0) {
                    return "var(--yellow-color)"
                } else if (aviaQuota === 3) {
                    return "#ff0000"
                }
            },
            minutsToTime(val) {
                let hour = Math.floor(val / 60)
                let minute = Math.round(val % 60)
                return (hour < 10 ? "0" + hour : hour) + ":" + (minute < 10 ? "0" + minute : minute)
            },
            timeToMinuts(val) {
                let time = val.split(":")
                let t1 = +time[0] * 60
                let t2 = +time[1]
                return t1 + t2
            },
            showPopover(text, e, down = false) {
                let rect = e.target.getBoundingClientRect();
                let res = {
                    x: rect.left + (rect.width / 2),
                    y: rect.top,
                    text: text,
                    height: rect.height,
                    down
                }
                this.$store.dispatch("A_SHOW_POPOVER", res);
            },
            clearAllSearchInput() {
                this.searchDeparture = "";
                this.searchArrival = "";
                this.searchAirline = "";

              bus.$emit("left-tickets-filters-reset-search")
            },
            changeSelectedFilters(val) {
                this.selectedFilters = [...val.filters];
                this.priceChange = false;
                this.dTimeChange = false;
                this.aTimeChange = false;

                if (val.sendRequest)
                    this.changeSecondFiltersOfUrl(false, true)
            },
            async setFiltersSpace() {
                await this.$nextTick();

                const mainFilters = document.querySelector("#main-filters");
                const ticketSecondFilters = document.querySelector("#ticketsSecondFilters");
                const mainTicketSecondFiltersSpace = document.querySelector("#mainTicketSecondFiltersSpace");
                const ticketResult = document.querySelector(".tickets-result.vertical-filters");
                const selectedFilters = document.querySelector(".selected-filters");

                if (this.fixedFilters) {
                    mainTicketSecondFiltersSpace.style.height =
                            mainFilters.clientHeight + (ticketSecondFilters?.clientHeight || 0) + "px";

                    if (ticketResult) {
                        ticketResult.style.paddingTop =
                            mainFilters.clientHeight + (ticketSecondFilters?.clientHeight || 0) + "px";
                    }
                } else {
                    if (ticketResult) {
                        ticketResult.style.paddingTop = (selectedFilters?.clientHeight || 0) + "px";
                    }
                }
            },
            fixedSecondFilters(val) {
                const mainFiltersTop = document.querySelector('#main-filters').clientHeight;
                const selectedFilters = document.querySelector('.selected-filters');
                if (!this.settings.FiltersDisplayOptions) {
                    this.$refs.secondFilters.style.top = val ? mainFiltersTop + "px" : "";
                } else if (selectedFilters) {
                    selectedFilters.style.top = val ? mainFiltersTop + "px" : "";
                }

                this.fixedFilters = val;
                bus.$emit("ticket_fixed_filters", val);
            },
            async setSelectedFiltersSpace() {
                await this.$nextTick();

                const ticketResult = document.querySelector(".tickets-result.vertical-filters");
                const selectedFilters = document.querySelector(".vertical-filters .selected-filters");
                if (!ticketResult) return;

                ticketResult.style.paddingTop = (selectedFilters?.clientHeight || 0) + "px";
            }
        },
        watch: {
            selectedFilters() {
                this.setSelectedFiltersSpace();
            },
            fixedFilters() {
                this.setFiltersSpace()
            },
            flexible() {
                this.openDateTable = true
            },
            "$route.fullPath"(val, oldVal) {
                if (val && !this.initDateTable) {
                    this.$nextTick(() => {
                        let newPath = val.split("&")
                            .filter(x => !x.includes("currency="))
                            .join("&");
                        let oldPath = oldVal.split("&")
                            .filter(x => !x.includes("currency="))
                            .join("&");
                        if (newPath !== oldPath && !this.isClickApply) {
                            this.setDateTable();
                        }
                        this.isClickApply = false
                    })
                }
            },
            getResultList: {
                deep: true,
                handler() {
                    this.$nextTick(() => {
                        this.setDateTable(this.cashDate);
                    })
                }
            },
            cashUrl(val) {
                bus.$emit("change-cash-url-of", val)
            },
            pageLoaderCountStatus(val) {
                if (val < 0) this.pageLoaderCountStatus = 0;

                bus.$emit("page-load", val > 0)
            },
            focus(val) {
                if (val) {
                    setTimeout(() => {
                        // this.createPriceTableColumns()
                    }, 0)
                }
            },
            secondFilters: {
                deep: true,
                handler() {
                    this.disabledSecondFilters();
                }
            },
            searchDeparture(val) {
                if (val.length) {
                    this.ticketsDepartureList = this.ticketsDepartureList.map(x => {
                        if (!x.Name.toLowerCase().includes(val.toLowerCase()) && !x.Code.toLowerCase().includes(val.toLowerCase())) {
                            x.isShow = false
                        } else {
                            x.isShow = true
                        }

                        return x
                    })
                } else {
                    this.ticketsDepartureList = this.ticketsDepartureList.map(x => {
                        x.isShow = true;
                        return x
                    })
                }
            },
            searchArrival(val) {
                if (val.length) {
                    this.ticketsArrivalList = this.ticketsArrivalList.map(x => {
                        if (!x.Name.toLowerCase().includes(val.toLowerCase()) && !x.Code.toLowerCase().includes(val.toLowerCase())) {
                            x.isShow = false
                        } else {
                            x.isShow = true
                        }

                        return x
                    })
                } else {
                    this.ticketsArrivalList = this.ticketsArrivalList.map(x => {
                        x.isShow = true;
                        return x
                    })
                }
            },
            searchAirline(val) {
                if (val.length) {
                    this.ticketsAirlineList = this.ticketsAirlineList.map(x => {
                        if (!x.Name.toLowerCase().includes(val.toLowerCase())) {
                            x.isShow = false
                        } else {
                            x.isShow = true
                        }

                        return x
                    })
                } else {
                    this.ticketsAirlineList = this.ticketsAirlineList.map(x => {
                        x.isShow = true;
                        return x
                    })
                }
            },
            priceTableData: {
                deep: true,
                handler() {
                    this.setPriceTableData();
                }
            }
        },
        beforeDestroy() {
            window.removeEventListener("resize", this.resize);
            window.removeEventListener("scroll", this.scroll);
            bus.$emit("page-load", false);
        },
        filters: {
            time(val) {
                let hour = Math.floor(val / 60)
                let minute = Math.round(val % 60)
                return (hour < 10 ? "0" + hour : hour) + ":" + (minute < 10 ? "0" + minute : minute)
            },
            removeStar(val) {
                return val.replace(/\*/g, "");
            },
            capitalize(val) {
                val = val[0].toUpperCase() + val.slice(1);
                return val
            }
        }
    }
</script>

<style scoped>
    .second-search-bar-wrap {
        position: relative;
        /*min-width: 1014px;*/
    }
    .second-search-bar-wrap.fixed {
        position: fixed;
        left: 0;
        right: 0;
        z-index: 9;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
    }

    .second-search-bar {
        position: relative;
        background-color: var(--white-color);
        border-top: 1px solid var(--lighten-4-color);
        border-bottom: 1px solid var(--lighten-4-color);
        padding: 0 60px;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .second-search-bar.active {
        /*z-index: 11;*/
    }

    .second-search-bar .search-controlers {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .second-search-bar .search-controlers .search-controler-item {
        position: relative;
        padding: 10px 15px 10px 20px;
        cursor: pointer;
    }

    .second-search-bar .search-controlers .search-controler-item:before {
        content: '';
        position: absolute;
        top: calc(50% - 10px);
        left: 0;
        background-color: #e0e0e0;
        width: 1px;
        height: 20px;
    }

    .second-search-bar .search-controlers .search-controler-item.active::after {
        content: '';
        position: absolute;
        bottom: -1px;
        left: 0;
        right: 0;
        background-color: #FF711D;
        height: 4px;
    }

    .second-search-bar .search-controlers .search-controler-item span {
        font-weight: 500;
        font-size: 15px;
        line-height: 18px;
        color: #727272;
        transition: all .2s;
    }

    .second-search-bar .search-controlers .search-controler-item.active span {
        color: var(--orange-color);
    }

    .second-search-bar .search-controlers .search-controler-item .angle-icon {
        margin: 0 0 2px 7px;
        transition: all .2s;
    }

    .second-search-bar .search-controlers .search-controler-item.active .angle-icon {
        transform: rotate(180deg)
    }

    .second-search-bar .result-positin-controlers {
        display: grid;
        grid-template-columns: 24px 24px 24px;
        grid-template-rows: 24px;
        grid-gap: 24px;
    }

    .second-search-bar .result-positin-controlers .controler {
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: all .2s;
    }

    .second-search-bar-list {
        position: relative;
        width: 100%;
        background-color: var(--white-color);
        padding: 28px 60px 20px;
        overflow: auto;
    }

    .fixed .second-search-bar-list {
        max-height: calc(100vh - 134px);
    }

    /*AVAILABILITY*/

    .availability-filter {
        /* display: grid;
        grid-template-columns: 280px 1fr auto;
        grid-gap: 80px; */
        display: flex;
        justify-content: space-between;
    }

    .availability-filter .price-block {
        width: 280px;
        margin-right: 80px;
    }

    .availability-filter .availability-checkbox-group-wrap {
        text-align: left;
        display: flex;
        flex-direction: column;
        gap: 10px;
        font-size: 15px;
    }

    .availability-filter .availability-checkbox-group-wrap .default {
        display: flex;
        align-items: end;
        gap: 20px;
    }

    .availability-filter .price-block .price-text {
        font-weight: normal;
        font-size: 15px;
        line-height: 18px;
        color: var(--dark-1-color);
        margin-bottom: 24px;
    }

    .availability-filter .price-block .price-text .blue-text {
        margin-left: 7px;
        font-weight: bold;
        font-size: 15px;
        line-height: 18px;
        color: var(--primary-color);
    }

    .availability-filter .availability-checkbox-group-wrap p {
        font-weight: normal;
        font-size: 15px;
        line-height: 18px;
        color: var(--dark-1-color);
        margin-bottom: 14px;
    }

    .availability-filter .availability-checkbox-group {
        display: grid;
        grid-template-columns: auto auto auto 1fr;
        grid-gap: 28px;
    }

    .availability-filter .done-btn {
        display: flex;
        align-items: flex-end;
    }

    .common-price-block {
      width: 300px;
      display: flex;
      flex-direction: column;
      gap: 15px;
    }

    .common-price-block .price-text {
      font-size: 15px;
    }

    .common-price-block .price-inputs {
      display: flex;
      gap: 5px;
    }

    .common-price-block .price-input {
      width: 135px;
      height: 30px;
      border: 2px solid var(--lighten-7-color);
      padding: 5px;
      font-size: 16px;
    }

    .common-price-block .price-inputs input:focus {
      border: 2px solid var(--primary-color);
      outline: none;
    }

    .common-price-block .dash {
        align-self: center;
        display: flex;
        background-color: var(--lighten-7-color);
        height: 2px;
        width: 15px;
    }
    /*AVAILABILITY END*/

    /*TOUR OPTIONS*/
    .tour-options .tour-options-filter {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-gap: 40px;
        margin-bottom: 15px;
    }

    .tour-options .tour-options-headline {
        font-weight: bold;
        font-size: 16px;
        line-height: 19px;
        color: var(--dark-1-color);
        margin-bottom: 10px;
    }

    .tour-options .btn-group {
        display: flex;
        justify-content: flex-end;
        padding-top: 20px;
    }

    .tour-options .btn-group .base-button:last-child {
        margin-left: 11px;
    }

    .tour-options .btn-group::before {
        content: "";
        position: absolute;
        bottom: 78px;
        left: 0;
        right: 0;
        height: 1px;
        background-color: var(--lighten-4-color);
    }
    .fixed .tour-options .btn-group::before {
        display: none;
    }

    .btn-group.fixed {
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        padding: 20px 60px 36px;
        background: var(--white-color);
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
        z-index: 1;
    }
    .btn-group.fixed::before {
        display: none;
    }

    .tour-options .type-search,
    .tour-options .program-search {
        max-width: 400px;
        margin-bottom: 16px;
    }

    .tour-options .options-list {
        overflow-y: auto;
        overflow-x: hidden;
        max-height: 175px;
    }

    .tour-options .options-list .options-item {
        padding: 7px 0;
        border-top: 1px solid var(--lighten-6-color);
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .tour-options .options-list .options-item .price-text {
        font-weight: 500;
        font-size: 14px;
        line-height: 28px;
        color: var(--orange-color);
    }

    /*TOUR OPTIONS END*/

    /*ACCOMMODATION*/
    .tour-accommodation .hotel-type-filter {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        margin-bottom: 20px;
    }

    .tour-accommodation .hotel-type-filter .hotel-type-item {
        margin: 0 20px 20px 0;
    }

    .tour-accommodation .hotel-type-filter .hotel-type-icon {
        margin-right: 10px;
    }

    .tour-accommodation .tour-accommodation-filter {
        display: grid;
        grid-template-columns: repeat(5, 1fr);
        grid-template-rows: 260px;
        grid-gap: 40px;
        margin-bottom: 20px;
    }

    .tour-accommodation .tour-accommodation-filter .headline {
        margin-bottom: 10px;
    }

    .tour-accommodation .btn-group {
        display: flex;
        justify-content: flex-end;
        padding-top: 20px;
    }

    .tour-accommodation .btn-group .base-button:last-child {
        margin-left: 11px;
    }

    .tour-accommodation .btn-group::before {
        content: "";
        position: absolute;
        bottom: 78px;
        left: 0;
        right: 0;
        height: 1px;
        background-color: var(--lighten-4-color);
    }
    .fixed .tour-accommodation .btn-group::before {
        display: none;
    }

    .tour-accommodation .cities-filter .cities-search,
    .tour-accommodation .resort-filter .resort-search,
    .tour-accommodation .category-filter .category-search,
    .tour-accommodation .food-filter .food-search,
    .tour-accommodation .hotel-filter .hotel-search {
        margin-bottom: 20px;
    }

    .tour-accommodation .accommodation-list {
        height: calc(100% - 35px);
        overflow: auto;
    }

    .tour-accommodation .accommodation-list.search-list {
        height: calc(100% - 100px);
        overflow: auto;
    }

    .tour-accommodation .accommodation-item {
        margin-bottom: 14px;
        display: flex;
        align-items: center;
    }

    .tour-accommodation .accommodation-item .star-icon {
        transition: all .7s;
        margin-left: 12px;
    }

    .tour-accommodation .accommodation-item .star-icon:nth-child(2) {
        transition-delay: .1s
    }

    .tour-accommodation .accommodation-item .star-icon:nth-child(3) {
        transition-delay: .2s
    }

    .tour-accommodation .accommodation-item .star-icon:nth-child(4) {
        transition-delay: .3s
    }

    .tour-accommodation .accommodation-item .star-icon:nth-child(5) {
        transition-delay: .4s
    }

    .tour-accommodation .accommodation-item:hover .star-icon {
        transform: rotateY(180deg);
    }

    /*ACCOMMODATION END*/

    /*FLIGHT*/
    .tour-flight .tour-flight-filter {
        position: relative;
        display: grid;
        grid-template-columns: 200px repeat(3, 1fr);
        grid-template-rows: 400px;
        grid-gap: 40px;
        margin-bottom: 20px;
    }
    .tour-flight .tour-flight-filter .line1 {
        position: absolute;
        top: 50%;
        left: 0;
        right: 360px;
        height: 1px;
        background-color: var(--lighten-4-color);
    }
    .tour-flight .tour-flight-filter .line2 {
        position: absolute;
        top: 0;
        left: calc(100% - 361px);
        right: 360px;
        height: 100%;
        background-color: var(--lighten-4-color);
    }

    .tour-flight .tour-flight-filter .headline {
        margin-bottom: 10px;
    }

    .tour-flight .airport-filter .headline:not(:first-child) {
        margin-top: 20px;
    }

    .tour-flight .btn-group {
        display: flex;
        justify-content: flex-end;
        padding-top: 20px;
    }

    .tour-flight .btn-group .base-button:last-child {
        margin-left: 11px;
    }

    .tour-flight .btn-group::before {
        content: "";
        position: absolute;
        bottom: 78px;
        left: 0;
        right: 0;
        height: 1px;
        background-color: var(--lighten-4-color);
    }

    .fixed .tour-flight .btn-group::before {
        display: none;
    }

    .tour-flight .airline-search,
    .tour-flight .arrival-search,
    .tour-flight .departure-search {
        margin-bottom: 20px;
    }

    .tour-flight .flight-list {
        height: calc(50% - 18px);
        overflow: auto;
    }

    .tour-flight .flight-list.airport-list {
        max-height: calc(50% - 100px);
    }

    .tour-flight .flight-list.airline-list {
        max-height: 96px;
        height: auto;
    }

    .tour-flight .flight-item {
        margin-bottom: 14px;
        display: flex;
        align-items: center;
    }

    .tour-flight .flight-item.class-combo,
    .tour-flight .flight-item.airline-combo {
        padding-top: 10px;
    }
    .tour-flight .flight-item.airline-combo {
        margin-bottom: 40px;
    }

    .tour-flight .flight-item .help-icon {
        margin-left: 5px;
        cursor: pointer;
    }

    .time-filter .standard-text {
        margin-bottom: 22px;
        white-space: nowrap;
        display: inline-block;
    }
    .time-filter .departure-there,
    .time-filter .arrival-back {
        width:  calc(100% - 20px);
        height: 50%;
    }
    .time-filter .arrival-back {
        margin-top: 10px;
    }

    /*FLIGHT END*/

    .not-result-text {
        margin-bottom: 10px;
    }

    .filters-falidation-popup .btn-group {
        margin-top: 15px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
    }

    .filters-falidation-popup .btn-group .base-button:last-child {
        margin-left: 10px;
    }

    .vertical-filters .selected-filters {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        z-index: 10;
        border-top: 1px solid var(--lighten-4-color);
        box-shadow: 0 4px 2px -2px rgba(0, 0, 0, 0.08);
        transition: all 0s;
    }

    .vertical-filters .selected-filters.fixed {
        position: fixed;
    }

    .vertical-filters .date-table-open {
        display: flex;
        align-items: flex-start;
    }

    .vertical-filters .date-table-open .date-filter {
        flex: 1;
        background: var(--white-color);
        margin: 18px 60px 0 16px;
        border-radius: 6px;
        padding: 40px 20px 20px 40px;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
    }

    .vertical-filters .date-table-open .date-filter /deep/ .date-table .top-slider {
        top: 5px;
        left: 40px;
        right: 20px;
    }
    .vertical-filters .date-table-open .date-filter /deep/ .date-table .left-slider {
        left: 20px;
    }

    @media (max-width: 1140px) {
        .second-search-bar-list {
            padding: 28px 20px 38px;
        }
        .tour-flight .tour-flight-filter {
            grid-gap: 20px;
        }
    }
</style>
